import {
  SET_AUTH_STATUS,
  SET_USERNAME,
  SET_PAYMENT_PLAN_TYPE,
  SET_SUBSCRIPTION_METHOD,
  SET_LANDING_SCROLL_POSITION,
  SET_GIFT_FORM_STATUS,
  SET_USER_DATA,
  SET_CREDIT_CARD_DATA,
  SET_SCHEDULE_DATA,
  SET_EXERCISES_DATA,
} from './actions';

export function setAuthStatus(authenticated) {
  return { type: SET_AUTH_STATUS, payload: authenticated };
}

export function setUserName(userName) {
  localStorage.setItem('userName', userName); /* should probably be mover from here in future */

  return { type: SET_USERNAME, payload: userName };
}

export function setPaymentPlanType(type) {
  return { type: SET_PAYMENT_PLAN_TYPE, payload: type };
}

export function setSubscriptionMethod(subscription_method) {
  return { type: SET_SUBSCRIPTION_METHOD, payload: subscription_method };
}

export function setGiftFormStatus(is_gift) {
  return { type: SET_GIFT_FORM_STATUS, payload: is_gift };
}

export function setLandingScrollPosition(activePosition) {
  return {
    type: SET_LANDING_SCROLL_POSITION,
    meta: {
      debounce: {
        time: 300,
      },
    },
    payload: activePosition,
  };
}

export function setUserData(user) {
  return { type: SET_USER_DATA, payload: user };
}

export function setCreditCardData(card) {
  return { type: SET_CREDIT_CARD_DATA, payload: card };
}

export function setScheduleData(schedule) {
  return { type: SET_SCHEDULE_DATA, payload: schedule };
}

export function setExercisesData(exercises) {
  return { type: SET_EXERCISES_DATA, payload: exercises };
}



// WEBPACK FOOTER //
// ./src/redux/actionCreators.js